import React from 'react'
import { Helmet } from 'react-helmet-async'

type Props = {
  script: object
}

const JsonLDScript = ({ script }: Props) => (
  <Helmet>
    <script type='application/ld+json'>{JSON.stringify(script)}</script>
  </Helmet>
)

export default JsonLDScript
